import { render } from "./FlappyFriendsForm.vue?vue&type=template&id=1bc04ebc"
import script from "./FlappyFriendsForm.vue?vue&type=script&lang=js"
export * from "./FlappyFriendsForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\casva\\repos\\cg-vue-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__